import classNames from 'classnames/bind';
import styles from './LoginBTN.module.scss';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import routes from '~/configs';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../Context/LoginProvider';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import ConfirmModal from '../ConfirmModal';
import { getData } from '~/helper/apiService';
import { ToastContext } from '../Context/ToastProvider';

const cx = classNames.bind(styles);

function LoginBTN({ setOpenSidebar = () => {} }) {
  const navigate = useNavigate();
  const { loginStatus, checkLogin } = useContext(LoginContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const { addToast } = useContext(ToastContext);

  const handleConfirm = async ()=>{
    const res = await getData("/user/logout");
    if(res.status === "success"){
      checkLogin();
      addToast(res);
    }
    setModalComponentContent(null);
  }
  const handleCancel = ()=>{
    setModalComponentContent(null);
  }

  const handleClick = () => {
    setOpenSidebar(false);
    if(!loginStatus){ 
      // login
      navigate(routes.login);
    }else{
      // logout
      setModalComponentContent(
      <ConfirmModal
        title="Xác nhận đăng xuất"
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
      />,
    );
    }
  };

  useEffect(() => {
    
  }, []);
  return <Button onClick={handleClick}>
    {loginStatus ? "Đăng xuất" : "Đăng nhập"}
  </Button>;
}

export default LoginBTN;
